<div class="iwb-variable-token-select dfield">
  <button type="button" class="iwb-variable-trigger" (click)="togglePicker()">
    <i class="fa-solid" [ngClass]="iconClass"></i>
    <span>{{ buttonLabel }}</span>
  </button>

  <div
    class="iwb-variable-popup-backdrop"
    *ngIf="isPickerOpen"
    (click)="closePicker()"></div>
  <div
    class="iwb-variable-popup"
    role="dialog"
    aria-modal="true"
    *ngIf="isPickerOpen">
    <div class="iwb-variable-popup-head">
      <div>
        <b>{{ label }}</b>
        <small>{{ popupHelpText }}</small>
      </div>
      <button
        type="button"
        class="iwb-variable-popup-close"
        aria-label="Close variable picker"
        (click)="closePicker()">
        <i class="fa-solid fa-xmark"></i>
      </button>
    </div>

    <input
      type="text"
      class="iwb-variable-search"
      [(ngModel)]="searchTerm"
      [placeholder]="placeholder" />

    <div class="iwb-variable-list">
      <ng-container *ngFor="let group of filteredGroups; trackBy: trackByGroup">
        <div class="iwb-variable-group">{{ group.group }}</div>
        <button
          type="button"
          class="iwb-variable-option-button"
          *ngFor="let variable of group.variables; trackBy: trackByVariable"
          (click)="selectVariable(variable.value)">
          <span class="iwb-variable-option">
            <b>{{ variable.label }}</b>
            <code>{{ variable.value }}</code>
          </span>
        </button>
      </ng-container>
      <div class="iwb-variable-empty" *ngIf="!filteredGroups.length">
        No matching options.
      </div>
    </div>
  </div>
</div>
